export const ELITE_ALARMS_URL = 'https://dashboard.elitealarms.com/';

// Mirrored pages are served from the apex domain. Going via dashboard. instead
// costs a 307 to the same path on apex, and that hop drops the query string —
// which is where reset tokens live, so send them straight to the final origin.
export const ELITE_ALARMS_PAGES_URL = 'https://elitealarms.com/';

// Paths EliteAlarms serves under the same name. Visitors who arrive on one of
// these — usually from an emailed or bookmarked link — are sent to the matching
// page rather than being dumped on the dashboard root.
const MIRRORED_PATHS = ['/account/reset', '/account/resetpassword', '/account/register'];

export function eliteAlarmsTarget(): string {
  const { pathname, search, hash } = window.location;
  // Trailing slashes and casing vary in the wild; the comparison should not.
  const normalisedPath = pathname.replace(/\/+$/, '').toLowerCase();

  if (!MIRRORED_PATHS.includes(normalisedPath)) {
    return ELITE_ALARMS_URL;
  }

  // Keep the query and hash: reset links carry their token there.
  return new URL(`${normalisedPath}${search}${hash}`, ELITE_ALARMS_PAGES_URL).toString();
}

export function redirectToEliteAlarms(): void {
  // replace() rather than assigning href, so the back button does not land the
  // user on this page again and bounce them straight through the redirect.
  window.location.replace(eliteAlarmsTarget());
}
